import { Component } from '@angular/core';
import { MainService as mainServiceMd } from '../../../md/service/main.service';
@Component({
  selector: 'app-work-flow',
  templateUrl: './work-flow.component.html',
  styleUrls: ['./work-flow.component.css']
})
export class WorkFlowComponent {

  constructor(private mainServiceMd: mainServiceMd) { }

  ngOnInit() {
    this.mainServiceMd.selectedModuleForCommonWorkFlow = 'KALYANMANDAP'
  }
}
